import React from "react";
import { DraftProposalStatus } from "../../../../../core";

interface UploadFeeletterApproveConfirmProps {
    isSaving: boolean;
    onApprove: () => Promise<void>;
    title: string | undefined;
    setStatusModalOpen: React.Dispatch<React.SetStateAction<{
        isOpen?: boolean | undefined;
        status?: DraftProposalStatus | undefined;
        documentCopyType?: string | undefined;
    }>>;
}

export function UploadFeeLetterApproveConfirm({ isSaving,
    onApprove,
    title,
    setStatusModalOpen }: UploadFeeletterApproveConfirmProps) {
    return (
        <>
            <div
                className="modal fade show in"
                id="exampleModal"
                aria-labelledby="exampleModalLabel"
                aria-hidden="true"
            >
                <div className="modal-dialog modal-dialog-confirm modal-dialog-centered">
                    <div className="modal-content rounded-0">
                        <div className="modal-body text-center">
                            <div className="container py-4">
                                <div className="row justify-content-center">
                                    <div className="col">
                                        <p className="font-sm font-weight-bold mb-4">
                                            Are you sure to Approve the {title}
                                        </p>
                                    </div>
                                </div>
                                <div className="row justify-content-center">
                                    <div className="col-auto">
                                        <button
                                            className="btn btn-outline-dark py-2 font-weight-semibold font-normal px-md-4 px-4 mr-3"
                                            onClick={() => {
                                                setStatusModalOpen({});
                                            }}
                                            disabled={isSaving}
                                        >
                                            Cancel
                                        </button>
                                        <button
                                            className="btn btn-primary py-2 font-weight-semibold font-normal px-4 flex-fill"
                                            disabled={isSaving}
                                            onClick={() => {
                                                onApprove();
                                            }}
                                        >
                                            Yes
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="modal-backdrop fade show"></div>
        </>
    );
}
